import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();
  const scrollPositions = useRef({});
  const previousPathname = useRef(pathname);

  useEffect(() => {
    // Save scroll position of previous page
    if (previousPathname.current && previousPathname.current !== pathname) {
      scrollPositions.current[previousPathname.current] = window.scrollY || 0;
    }

    previousPathname.current = pathname;

    // Don't auto-scroll if we have a saved position (user is going back)
    // This allows the useNavigationHistory hook to restore the position
    const savedPosition = scrollPositions.current[pathname];
    if (!savedPosition || savedPosition === 0) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;
